import React, { FC, useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

import ProductImg1 from "images/Devi-Plastic/3-Heavy-Sink-Coupling.webp";
import ProductImg2 from "images/Devi-Plastic/3-LITE-MS-SS-SKREW.webp";
import ProductImg3 from "images/Devi-Plastic/4 -Heavy-with-Reducer.webp";
import ProductImg4 from "images/Devi-Plastic/4 -JUMBO.webp";
import ProductImg5 from "images/Devi-Plastic/4-HEAVY-ROYAL.webp";
import ProductImg6 from "images/Devi-Plastic/4-LITE-COUPLING.webp";

import backgroundLineSvg from "images/Moon.svg";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Next from "shared/NextPrev/Next";
import Prev from "shared/NextPrev/Prev";
import NcImage from "shared/NcImage/NcImage";

interface Hero2DataType {
  image: string;
  heading: string;
  subHeading: string;
  btnText: string;
  btnLink: string;
}

const DATA: Hero2DataType[] = [
  {
    image: ProductImg1,
    heading: "3 inch Heavy Sink Coupling",
    subHeading: "Extra heavy build for long-lasting performance 💪",
    btnText: "Explore now",
    btnLink: "/product/3-inch-heavy-sink-coupling",
  },
  {
    image: ProductImg2,
    heading: "3 inch Lite MS & SS Screw Coupling",
    subHeading: "Lightweight design with strong MS & SS screws ⚙️",
    btnText: "Explore now",
    btnLink: "/product/3-inch-lite-ms-ss-screw",
  },
  {
    image: ProductImg3,
    heading: "4 inch Heavy Coupling with Reducer",
    subHeading: "Perfect fit with reducer for secure drainage 🔧",
    btnText: "Explore now",
    btnLink: "/product/4-inch-heavy-coupling-with-reducer",
  },
  {
    image: ProductImg4,
    heading: "4 inch Jumbo Sink Coupling",
    subHeading: "Wide jumbo size for high water flow 🚿",
    btnText: "Explore now",
    btnLink: "/product/4-inch-jumbo-sink-coupling",
  },
  {
    image: ProductImg5,
    heading: "4 inch Heavy Royal Sink Coupling",
    subHeading: "Premium heavy quality with royal finish 👑",
    btnText: "Explore now",
    btnLink: "/product/4-inch-heavy-royal-sink-coupling",
  },
  {
    image: ProductImg6,
    heading: "4 inch Lite Sink Coupling",
    subHeading: "Smart lightweight coupling for everyday use ✨",
    btnText: "Explore now",
    btnLink: "/product/4-inch-lite-sink-coupling",
  },
];

const SectionHero2: FC<{ className?: string }> = ({ className = "" }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    Autoplay({
      delay: 5000,
      stopOnInteraction: true,
    }),
  ]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Embla viewport */}
      <div ref={emblaRef} className="overflow-hidden">
        <div className="flex">
          {DATA.map((item, index) => (
            <div key={index} className="flex-[0_0_100%] min-w-0 relative">
              {/* Background */}
              <div className="absolute inset-0 bg-gray-200">
                <img
                  src={backgroundLineSvg}
                  className="w-full h-full object-contain opacity-40"
                  alt=""
                />
              </div>

              {/* Content */}
              <div className="relative container px-2 lg:px-20 py-10 lg:py-16 ">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-16 lg:min-h-[50vh] items-center">
                  {/* LEFT : TEXT */}
                  <div className=" order-2 lg:order-1 flex flex-col lg:justify-center space-y-6 lg:space-y-8 text-center lg:text-left">
                    <span className="block text-slate-700 text-xs sm:text-base md:text-lg">
                      {item.subHeading}
                    </span>

                    {index === 0 ? (
                      <>
                        <h1 className="font-semibold text-sm sm:text-4xl  text-slate-900 leading-tight">
                          Devi Plastic – Manufacturer of Premium Sink Couplings
                        </h1>
                        <h2 className="font-semibold text-sm  text-slate-900 leading-tight">
                          {item.heading}
                        </h2>
                      </>
                    ) : (
                      <h2 className="font-semibold text-xl sm:text-2xl md:text-5xl xl:text-6xl text-slate-900 leading-tight">
                        {item.heading}
                      </h2>
                    )}

                    {/* <h2 className="font-semibold text-3xl sm:text-4xl md:text-5xl xl:text-6xl text-slate-900 leading-tight">
                      {item.heading}
                    </h2> */}

                    <div className="flex justify-center lg:justify-start">
                      <ButtonPrimary
                        href={item.btnLink as any}
                        className="bg-primary-500"
                      >
                        {item.btnText}
                      </ButtonPrimary>
                    </div>
                  </div>

                  {/* RIGHT : IMAGE */}
                  <div className=" order-1 lg:order-2 flex justify-center lg:justify-end items-center">
                    <NcImage
                      src={item.image}
                      alt={item.heading}
                      className="
                        h-full
        w-auto
        object-contain
                      "
                      containerClassName="
                        h-56
      sm:h-64
      md:h-72
      lg:h-80
      xl:h-96
      flex
      items-center
      justify-center
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Prev / Next */}
      <Prev
        className="absolute left-3 top-1/2 -translate-y-1/2 z-10"
        onClickPrev={() => emblaApi?.scrollPrev()}
      />
      <Next
        className="absolute right-3 top-1/2 -translate-y-1/2 z-10"
        onClickNext={() => emblaApi?.scrollNext()}
      />

      {/* Dots */}
      <div className="absolute bottom-2 lg:bottom-6 left-1/2 -translate-x-1/2 flex gap-3 z-10">
        {DATA.map((_, index) => (
          <button
            key={index}
            onClick={() => emblaApi?.scrollTo(index)}
            className={`h-1.5 w-10 rounded-full transition-all duration-300 ${
              selectedIndex === index ? "bg-slate-900" : "bg-white/70"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionHero2;
